/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Schule_Am_Ried3Inputs */

const en__field__enum_schoolname_schule_am_ried3 = /** @type {(inputs: _Field__Enum_Schoolname_Schule_Am_Ried3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

const de__field__enum_schoolname_schule_am_ried3 = /** @type {(inputs: _Field__Enum_Schoolname_Schule_Am_Ried3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schule-am-Ried`)
};

/**
* | output |
* | --- |
* | "Frankfurt" |
*
* @param {_Field__Enum_Schoolname_Schule_Am_Ried3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_schule_am_ried3 = /** @type {((inputs?: _Field__Enum_Schoolname_Schule_Am_Ried3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Schule_Am_Ried3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_schule_am_ried3(inputs)
	return de__field__enum_schoolname_schule_am_ried3(inputs)
});
export { _field__enum_schoolname_schule_am_ried3 as "_field__enum_schoolName_Schule_am_Ried" }